import { ApiClient } from "lib/utils/client/apiClient";

export const builderPropertyListingDetails = async (data:{propertyUnitId:string,builderId:string}) => {
    return ApiClient(`/property/unit/details`,{
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const unitStatusUpdate = async (data:{propertyUnitId:string,documentId:string,type:string,status:string}) => {
    return ApiClient(`/property/update/documents`,{
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const propertyUnitInspectionDetails = async (inspectionId:string) => {
    return ApiClient(`/inspection/${inspectionId}`,{
        method: 'GET'
    });
};

export const getInspectorsByType = async (data: {status: string,inspectorType: string, search?:string, page:number, limit:number}) => {
    return ApiClient(`/inspector-user/all`,{
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const assignInspectorToPropertyUnit = async (data: {inspection_type: string, inspection_amount: number, inspector_id: string, property_unit_id: string}) => {
    return ApiClient(`/inspection/create`,{
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const updateInspectorOfPropertyUnitInspection = async (inspection_id: string, data: {inspector_id: string, status: string}) => {
    return ApiClient(`/inspection/update/${inspection_id}`,{
        method: 'PATCH',
        body: JSON.stringify(data)
    });
};

export const updatePrimaryInspectionReportStatus = async (data:{inspectionReportId:string, rejectionReason?:string, status:string}) => {
    return ApiClient(`/inspection/primary-report`,{
        method: 'PATCH',
        body: JSON.stringify(data)
    });
}

export const updateSecondaryInspectionReportStatus = async (data:{inspectionReportId:string, rejectionReason?:string, status:string}) => {
    return ApiClient(`/inspection/secondary-report`,{
        method: 'PATCH',
        body: JSON.stringify(data)
    });
}

export const makePaymentAndApproveInspection = async (data: {inspectionId:string, inspectionAmount: number, paymentMethod: string}) => {
    return ApiClient(`/inspection-payment`,{
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const updateStatusPropertyUnitById = async (propertyUnitId: string, data: {status: string, rejection_reason?: string}) => {
    return ApiClient(`/property-unit/update/status/${propertyUnitId}`,{
        method: 'PATCH',
        body: JSON.stringify(data)
    });
}

export const getEarnestDepositById = async (id: string) => {
    return ApiClient(`/earnest-deposit-payment/${id}`,{
        method: 'GET'
    });
};

export const getEarnestDepositGlobalValues = async (type:string) => {
    return ApiClient(`/earnest-deposit?type=${type}`,{
        method: 'GET'
    });
}

export const updateEarnestDepositGlobalValues = async (id:string, data: {inspection_report: number, deed_recording_percentage?: number, rentAgreementPercentage?: number, tax_percentage: number, identity_verification_percentage: number, transport_logistics_percentage: number, platform_fee_percentage: number}) => {
    return ApiClient(`/earnest-deposit/${id}`,{
        method: 'PATCH',
        body: JSON.stringify(data)
    });
}

export const createEarnestDepositGlobalValues = async (data: {inspection_report: number, deed_recording_percentage?: number, rentAgreementPercentage?: number, tax_percentage: number, identity_verification_percentage: number, transport_logistics_percentage: number, platform_fee_percentage: number, depositType?: string}) => {
    return ApiClient(`/earnest-deposit/create`,{
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const updateEarnestDepositPaymentById = async (data: {inspection_report: number, deed_recording_percentage: number, tax_percentage: number, identity_verification_percentage: number, transport_logistics_percentage: number, platform_fee_percentage: number, earnestPaymentId: string}) => {
    return ApiClient(`/earnest-deposit-payment/recalculate`,{
        method: 'POST',
        body: JSON.stringify(data)
    });
};
